import { Component, OnInit, ComponentFactoryResolver } from '@angular/core';
import { DataEntityViewComponent } from '../../data-entity-view/data-entity-view.component';
import { YDataEntity } from 'src/app/models/data-entities/y-data-entity';
import { WorkflowContextService } from 'src/app/services/workflow-context.service';
import { LayoutService } from 'src/app/services/layout.service';

@Component({
    selector: 'wm-y-data-entity-view',
    templateUrl: './y-data-entity-view.component.html',
    styleUrls: ['./y-data-entity-view.component.css'],
    standalone: false
})
export class YDataEntityViewComponent extends DataEntityViewComponent
  implements OnInit {
  constructor(public layoutService: LayoutService, componentFactoryResolver: ComponentFactoryResolver, context: WorkflowContextService) {
    super(layoutService, componentFactoryResolver, context);
  }
  yEntity: YDataEntity;

  ngOnInit() {
    this.yEntity = <YDataEntity>this.entity;
  }
}
